import React from 'react'
import Header from '../../template/Header'
import { Breadcrumbs, Typography } from '@mui/material'
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';


const Unauthorized = (props) => {

    return (
        <div className="">
            <Header title="Unauthorized" >
                <Breadcrumbs aria-label="breadcrumb" separator="/" className="!text-gray-600" >
                    <Typography ><HomeOutlinedIcon className="text-gray-600" fontSize="small" /></Typography>
                    <Typography ><span className="text-gray-600">Unauthorized</span></Typography>
                </Breadcrumbs>
            </Header>

            <div style={{ height: "calc( 100vh - 145px )" }} className="flex flex-col justify-center items-center gap-8">
                <div>
                    <img src="/brand/goback-logo-black.png" alt="goback" className="h-16" />
                </div>
                <p className="text-2xl">Unauthorized</p>
                <p className="font-thin">You are not authorized to access this page, please contact your administrator</p>
                {props.roles && <p className="font-thin">Required Roles: {props.roles.join(", ")}</p>}
                {props.permisos && <p className="font-thin">Required Permissions: {props.permisos.join(", ")}</p>}
            </div>
        </div>
    )
}

export default Unauthorized 